































import { Component, Vue, Inject, Prop, Emit, Watch } from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../lib/ajax';
import AbpBase from '../../lib/abpbase';
import AppConst from '../../lib/appconst';
@Component
/*
 * @Params		request		导入接口地址，必传
 * @Params		value		显示与隐藏导入弹出
 * @Function	callback	导入成功后的回调，可用于上传成功后调用callback刷新表格数据
 */
export default class ImportModal extends AbpBase {
	@Prop({type: String, required: true}) request:string;
	@Prop(Boolean) value:boolean;
	initData:any = {
		submitLoading: false,
		fileUrl: AppConst.fileUrl
	}
    // 导入格式限制
    handleCheckError(file:any) {
    	this.$Notice.warning({
            title: '文件格式错误',
            desc: '文件 ' + file.name + ' 格式错误, 请选择xls或者xlsx格式的文件'
        });
    }
    // 导入文件上传前校验
    handleCheck() {
    	const check = (this as any).$refs.importUpload.fileList.length < 1;
        if (!check) {
            this.$Notice.warning({
                title: '每次只能导入一个文件'
            });
        }
        return check;
    }
	// 导入
    async handleSubmit() {
    	let importFileName:any = (this as any).$refs.importUpload.fileList.map((res:any) => {
    		return res.response.result;
    	})
    	if(importFileName.length == 0) {
    		this.$Message.error('请上传需要导入数据的文件！');
    		return;
    	}
    	this.initData.submitLoading = true;
    	await Ajax.post(this.request, {importFileName: importFileName[0]}).then((res:any)=>{
    		this.handleSuccess();
        }).catch(() => {
        	this.initData.submitLoading = false;
        })
    }
    @Emit('input')
    handleClose(flog:any) {
    	if(flog == false) {
    		(this as any).$refs.importUpload.clearFiles();
    	}
    }
    @Emit('callback')
    handleSuccess() {
    	this.$Message.success('导入成功！');
    	this.initData.submitLoading = false;
    	this.handleClose(false);
    }
}
